// ClientDetail/Components/Documents/Documents.jsx
import React from 'react';
import Classes from './Documents.module.css';
import RecordTable from './RecordTable/RecordTable';

export default function Documents({ loading, user, userId }) {
  return (
    <div className={Classes.hero}>
      <RecordTable
        loading={loading}
        documents={user?.documents || []}
        userId={userId}
      />
    </div>
  );
}
